import { useIntl } from 'react-intl'

import { Badge } from '@mui/material'

import FilterIcon from 'app/assets/icons/search/filter.svg'
import Button, { ButtonProps } from 'app/components/base/Button'

interface FiltersButtonProps extends ButtonProps {
  hideBadge?: boolean
}

const FiltersButton: RFC<FiltersButtonProps> = ({
  hideBadge,
  sx,
  ...props
}) => {
  const intl = useIntl()

  return (
    <Button
      size="small"
      variant="text"
      endIcon={
        <Badge
          color="secondary"
          variant="dot"
          invisible={hideBadge}
          sx={{
            '.MuiBadge-badge': {
              mt: 0.4,
              minWidth: 14,
              height: 14
            }
          }}
        >
          <FilterIcon />
        </Badge>
      }
      sx={{ width: 110, minWidth: 110, ...sx }}
      {...props}
    >
      {intl.formatMessage({ defaultMessage: 'Filters' })}
    </Button>
  )
}

export default FiltersButton
